// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__HSOtA","obliqueLineWrap":"membershipbadge_obliqueLineWrap__uU-AE","obliqueLine":"membershipbadge_obliqueLine__1x1ly"};